export default __webpack_public_path__ + "static/media/main-carousel.fadcec4b.jpg";